module.exports = __webpack_public_path__ + "bariol_bold-webfont.asset.aecd7aa1a71309dadfc9375dc727a582.woff";